import React, { Component }  from 'react'
// import PropTypes from 'prop-types'
// import classnames from 'classnames'

import { Link } from 'react-router-dom'

import './projects-header.css'

export default class ProjectHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    return (
      <div className="projects_header">
        <div className="header_wrapper">
          <div className="header left_bar">
            <Link to="/" className="text page_title">zenpirate</Link>
            <Link to="/projects" className="text project_name">Projects</Link>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectHeader/index.js